import clsx from 'clsx';
import { useFormik } from 'formik';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { PlusIcon } from '../../../Assets/icons';
import useClinic from '../../../Features/useClinic';
import useDoctor from '../../../Features/useDoctor';
import useProfile from '../../../Features/useProfile';
import AlertModal from '../../../Modals/AlertModal';
import { serviceSchema } from '../../../Schema';
import Button from '../../UI/Button';
import { Input } from '../../UI/Input';
import OpdFeeSection from '../OpdFeeSection';
import RenderServiceList from './RenderServiceList';
import classes from './ServicesContainer.module.css';
const initialValues = {
  id: 0,
  name: '',
  fee: ''
};
const ServicesContainer = () => {
  const { editClinicFee, loading: clinicLoading } = useClinic();
  const [formattedServiceFee, setFormattedServiceFee] = useState('');
  const [service, setService] = useState(null);
  const [showAreYouSureModal, setShowAreYouSureModal] = useState(false);
  const { getDoctorFee } = useProfile();
  const { getAllServicesListing, loading, deleteServiceSubmit, addOrEditServiceSubmit } =
    useDoctor();
  const allServices = useSelector((state) => state?.serviceReducer?.services);
  const formik = useFormik({
    initialValues,
    validationSchema: serviceSchema,
    onSubmit: (values, { resetForm }) => {
      const afterSuccess = () => {
        getAllServicesListing();
        resetForm();
        setService(null);
        setFormattedServiceFee('');
      };
      addOrEditServiceSubmit(values, afterSuccess);
    }
  });
  const {
    touched,
    errors,
    values,
    handleSubmit,
    setValues,
    setFieldValue,
    setFieldTouched,
    setTouched
  } = formik;
  const handleChangeWithTouch = (field, value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };
  const onEditService = (service) => {
    setTouched({
      name: true, // Mark the name field as touched
      fee: true // Mark the fee field as touched
    });
    setValues({
      ...service
    });
    handleServiceFeeChange(String(service?.serviceFees));
  };
  const onCancel = () => {
    setShowAreYouSureModal(false);
  };
  //delete Item from the list
  const deleteService = (id) => {
    deleteServiceSubmit({ serviceId: id }, () => {
      onCancel();

      setFormattedServiceFee('');
    });
  };
  const handleServiceFeeChange = (value) => {
    const rawValue = value.replace(/,/g, '');
    const formattedValue = Number(rawValue).toLocaleString();
    handleChangeWithTouch('serviceFees', rawValue);
    setFormattedServiceFee(formattedValue);
  };
  return (
    <>
      <div className={classes.wrapper}>
        <header className={classes.header}>
          <h2 className={classes.title}>Service(s)</h2>
          <Button
            className={classes.serviceAction}
            leftIcon={<PlusIcon size={15} color="#fff" />}
            label={'Add'}
          />
        </header>
        <section className={clsx(classes.serviceBoard, 'scrollbar1')}>
          <div className={classes.formWrapper}>
            <div className={classes.opdWrapper}>
              <OpdFeeSection
                loading={clinicLoading}
                allServices={allServices}
                onSubmit={(params) => {
                  editClinicFee(params, () => {
                    getDoctorFee();
                  });
                }}
              />
            </div>
            <form onSubmit={handleSubmit} className={classes.actionWrapper}>
              <Row className={classes.formActions}>
                {/* <div> */}
                <Col className="pe-0" xs={5}>
                  <Input
                    id={'Service Name'}
                    label={'Service Name'}
                    placeholder="Enter Service(s)"
                    setter={(value) => handleChangeWithTouch('serviceName', value)}
                    value={values?.serviceName}
                    disabled={service}
                  />
                </Col>
                {/* </div> */}
                {/* <div> */}
                <Col className="pe-0" xs={5}>
                  <Input
                    regexType="format"
                    id={'Service Fee'}
                    value={formattedServiceFee || values?.serviceFees}
                    label={'Service Fee'}
                    placeholder="Enter Fee"
                    setter={handleServiceFeeChange}
                  />
                </Col>
                {/* </div> */}
                <Col xs={2} style={{ display: 'flex' }} className={classes.submitAction}>
                  <Button
                    style={{ height: '51px', alignSelf: 'end' }}
                    className={classes.cta}
                    type="submit"
                    label={'Save'}
                    disabled={loading}
                  />
                </Col>
              </Row>
            </form>
            <div className={classes.errorContainer}>
              <p className="errorText">{touched?.serviceName && errors?.serviceName}</p>
              <p className="errorText">{touched?.serviceFees && errors?.serviceFees}</p>
            </div>
          </div>
          <div className={clsx(classes.listWrapper, 'scrollbar1')}>
            <RenderServiceList
              list={allServices?.filter((data) => data?.serviceId != null)}
              onEditService={onEditService}
              setter={setService}
              onDeleteService={() => setShowAreYouSureModal(true)}
            />
          </div>
        </section>
      </div>
      {showAreYouSureModal && (
        <AlertModal
          loading={loading}
          title={'Delete Service'}
          content={
            <span>
              Are you sure you want to delete the service{' '}
              <span className={classes.contentName}>{service?.serviceName} </span>
            </span>
          }
          onConfirm={() => {
            deleteService(service?.serviceId);
          }}
          show={showAreYouSureModal}
          setShow={setShowAreYouSureModal}
        />
      )}
    </>
  );
};
export default ServicesContainer;
